<table mat-table [dataSource]="refundList" class="mat-elevation-z8" [showEmptyIf]="refundList.length === 0"
    eigTableEmpty [emptyText]="'Records not found'">

    <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef> Refund ID </th>
        <td mat-cell *matCellDef="let element"> {{element.refund_transaction_id}} </td>
    </ng-container>

    <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef> Amount </th>
        <td mat-cell *matCellDef="let element"> {{element.amount}} {{element.currency}} </td>
    </ng-container>

    <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef> Status </th>
        <td mat-cell *matCellDef="let element"> {{element.status}} </td>
    </ng-container>

    <ng-container matColumnDef="withdrawal_reference_id">
        <th mat-header-cell *matHeaderCellDef> Withdraw id </th>
        <td mat-cell *matCellDef="let element"> {{element.withdrawal_reference_id}} </td>
    </ng-container>

    <ng-container matColumnDef="deposit_reference_id">
        <th mat-header-cell *matHeaderCellDef> Deposit id </th>
        <td mat-cell *matCellDef="let element"> {{element.deposit_reference_id}} </td>
    </ng-container>

    <ng-container matColumnDef="decline_code">
        <th mat-header-cell *matHeaderCellDef> Decline code </th>
        <td mat-cell *matCellDef="let element"> {{element.decline_code}} </td>
    </ng-container>

    <ng-container matColumnDef="decline_reason">
        <th mat-header-cell *matHeaderCellDef> Decline reason </th>
        <td mat-cell *matCellDef="let element"> {{element.decline_reason}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns" class="primary title"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>